export class CommunityMaster {
}
CommunityMaster.MergedDefaultId = "00000000-0000-0000-0000-000000000001";
CommunityMaster.UnmergedDefaultId = "00000000-0000-0000-0000-000000000000";
//# sourceMappingURL=community-master.js.map